import * as React from "react";
import {Grid} from "@material-ui/core";
import styled from "styled-components";
import {Colors} from "../../theme/colors";

export const DetailsPropWrapper: React.FC<Props> = ({header, text, style}) => (
    <Grid item container direction={"column"} style={style}>
        <Grid item>
            <StyledPropDetailsHeader>
                {header}
            </StyledPropDetailsHeader>
        </Grid>

        <Grid item>
            <StyledPropDetailsVal>
                {text || '-'}
            </StyledPropDetailsVal>
        </Grid>
    </Grid>
);

interface Props {
    header: string;
    text: string;
    style?: any;
}

const StyledPropDetailsHeader = styled('p')`
  color: ${Colors.violet};
  font-weight: 600;
`;

const StyledPropDetailsVal = styled('p')`
  font-size: 0.9rem;
  margin-top: 0.3rem;
  white-space: pre-line;
`;
